import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { InsertWasherBody, SearchWashersResponse, UpdateWasherBody } from "./types/washers";
import { SCREW_CONNECTOR_ADMIN_URL } from "./screwConnectorAdminUrl";
import { SCREW_CONNECTOR_URL } from "./screwConnectorUrl";

// Keyed by code.
export const useScrewConnectorWashersApi = () => {
  // The calculator reads the washers too.
  const crud = createAdminCrudApi<SearchWashersResponse, InsertWasherBody, UpdateWasherBody>(
    useApi(),
    SCREW_CONNECTOR_ADMIN_URL,
    "washers",
    [SCREW_CONNECTOR_URL],
  );

  return {
    useWashers: crud.useSearch,
    getWashers: crud.search,
    insertWasher: async (body: InsertWasherBody): Promise<void> => {
      await crud.insert(body);
    },
    updateWasher: (code: string, body: UpdateWasherBody) => crud.update(encodeURIComponent(code), body),
    deleteWasher: (code: string) => crud.remove(encodeURIComponent(code)),
  };
};

export default useScrewConnectorWashersApi;
